<template>
  <el-dialog :title="form.id?'编辑':'新增'" :visible.sync="formVisible" width="800px" :close-on-click-modal="false">
    <el-form ref="dataForm" :rules="formRules" :model="form" label-position="right" size="small" label-width="120px">
      <el-form-item label="关键字" prop="keyword">
        <el-input v-model="form.keyword" placeholder="请输入" maxlength="50" show-word-limit />
      </el-form-item>
      <el-form-item label="回复话术" prop="content">
        <el-input v-model="form.content" placeholder="请输入" maxlength="50" show-word-limit />
      </el-form-item>
      <el-form-item label="状态" prop="isEnable">
        <el-switch v-model="form.isEnable" :active-value="true" :inactive-value="false"></el-switch> {{form.isEnable?'启用':'禁用'}}
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="formVisible = false">
        取消
      </el-button>
      <el-button type="primary" @click="doCreate()">
        确认
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import custServiceAutoReplyApi from '@/api/customer/custServiceAutoReply'
function initFormBean() {
  const formBean = {
    keyword: null,
    content: null,
    isEnable: false,
  }
  return formBean
}

export default {
  data() {
    return {
      form: initFormBean(),
      formVisible: false,
      formRules: {
        keyword: [{ required: true, message: '请输入关键字', trigger: 'blur' }],
        content: [{ required: true, message: '请输入回复话术', trigger: 'change' }],
        isEnable: [{ required: true, message: '请选择状态', trigger: 'change' }],
      },
      isRepSub: false
    }
  },
  created() {

  },
  methods: {
    resetForm() {
      this.form = initFormBean()
    },
    handleCreate() {
      this.resetForm()
      this.formVisible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].clearValidate()
      })
    },
    handleUpdate(row) {
      this.resetForm()
      this.form = { ...row }
      this.formVisible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].clearValidate()
      })
    },
    doCreate() {
      this.$refs["dataForm"].validate((valid) => {
        if (valid) {
          if (this.isRepSub) return
          this.isRepSub = true
          if (this.form.id > 0) {
            custServiceAutoReplyApi.update(this.form).then((data) => {
              this.postCallback(data)
            }).catch(res => {
              this.isRepSub = false
            });
          } else {
            custServiceAutoReplyApi.create(this.form).then((data) => {
              this.postCallback(data)
            }).catch(res => {
              this.isRepSub = false
            });
          }
        }
      });
    },
    postCallback(data) {
      this.isRepSub = false
      this.$message.success('操作成功')
      this.formVisible = false;
      this.$emit('created')
    },
  }
}
</script>
<style lang="scss" scoped>
::v-deep .el-select {
  width: 100%;
}

.input-box {
  display: flex;
  align-items: center;
  margin-bottom: 18px;
  i {
    cursor: pointer;
  }
}

.input-box:last-child {
  margin-bottom: 0;
}

::v-deep .el-icon-plus,
.el-icon-minus {
  margin-left: 4px;
  color: #60b7dc;
}
</style>
